export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/faces/erik-lucatero-2-2051e0e847124c536df9c01a3f672032.jpg";